<template lang="pug">
  #app
    #loading(v-if="isLoading")
      .lottie(ref="lottie")
    template(v-else)
      transition(name='fade' appear)
        .wrap.main
          SelectView
          SelectColor
</template>

<script>
import 'reset.css';
import lottie, { AnimationItem } from 'lottie-web';
import Preload from '@/assets/js/PreloadImages';
import animationData from '@/assets/json/data';
import SelectColor from '@/components/SelectColor';
import SelectView from '@/components/SelectView';
import { mapActions } from 'vuex';

export default {
  name: 'App',
  components: {
    SelectColor,
    SelectView,
  },
  created() {
    window.addEventListener('resize', this.setWindowSize);
  },
  async mounted() {
    await this.loadAnimation();
    await Preload.loadImages();
    // lottieのロード終了を通知する
    this.isLoadComplete = true;
  },
  data: () => ({
    isLoadComplete: false,
    isLoading: true,
    animation: AnimationItem,
  }),
  methods: {
    ...mapActions(['setWindowSize']),
    // 最初のロード画像(lottie形式)を再生する
    async loadAnimation() {
      this.animation = await lottie.loadAnimation({
        container: this.$refs.lottie,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData,
      });
      this.animation.onLoopComplete = this.onLoopComplete;
    },
    onLoopComplete() {
      if (this.isLoadComplete) {
        this.animation.stop();
        this.setWindowSize();
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#loading {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.lottie {
  width: 600px;
}

.main {
  display: flex;
  flex-flow: row nowrap;
}

@include sp_layout() {
  .lottie {
    width: vw(600);
  }
  .main {
    display: block;
    overflow: hidden;
  }
}
</style>
